"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TeamModal_1 = __importDefault(require("./TeamModal"));
exports.default = TeamModal_1.default;
